"use client";

import { c as _c } from "react/compiler-runtime";
import { UserCheck, UserMinus, UserPlus } from "lucide-react";
import { Spinner } from "@/features/home-v2/ui";
import { useFollowToggle, type FollowState } from "./hooks/useFollowToggle";
import "./follow.css";
type Props = {
  username: string;
  initialState?: FollowState;
  isFa: boolean;
  /** `sm` in a card; `lg` is the profile hero's call to action. */
  size?: "sm" | "lg";
  /** See useFollowToggle: the state arrives with the list. */
  fromList?: boolean;
  /** See useFollowToggle: the new state, once the server took it. */
  onChange?: (state: FollowState) => void;
};

/**
 * The v2 face of `FollowButton`; the behaviour is the same hook. Two looks that
 * cannot be mistaken: «دنبال کردن» is the solid call to action; once followed it
 * is a quiet tinted «دنبال‌شده» with a tick, and a hover says what a click does —
 * «لغو دنبال», in the warning colour. Both labels share one cell, so the button
 * keeps its width when the label changes.
 */
export default function ArtistFollowButton(t0) {
  const $ = _c(20);
  const {
    username,
    initialState,
    isFa,
    size: t1,
    fromList,
    onChange
  } = t0;
  const size = t1 === undefined ? "sm" : t1;
  let t2;
  if ($[0] !== fromList || $[1] !== initialState || $[2] !== isFa || $[3] !== onChange || $[4] !== username) {
    t2 = {
      username,
      initialState,
      isFa,
      fromList,
      onChange
    };
    $[0] = fromList;
    $[1] = initialState;
    $[2] = isFa;
    $[3] = onChange;
    $[4] = username;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const {
    isFollowed,
    busy,
    toggle
  } = useFollowToggle(t2);
  const className = `v2-btn ${size === "lg" ? "v2-btn--lg" : "v2-btn--sm"} v2-follow v2-focus`;
  const undo = isFa ? "\u0644\u063A\u0648 \u062F\u0646\u0628\u0627\u0644" : "Unfollow";
  const t3 = isFollowed || undefined;
  const t4 = isFollowed ? undo : undefined;
  const t5 = busy || undefined;
  let t6;
  if ($[6] !== busy || $[7] !== isFa || $[8] !== isFollowed || $[9] !== undo) {
    t6 = busy ? <><Spinner />{isFollowed ? isFa ? "\u062F\u0646\u0628\u0627\u0644\u200C\u0634\u062F\u0647" : "Following" : isFa ? "\u062F\u0646\u0628\u0627\u0644 \u06A9\u0631\u062F\u0646" : "Follow"}</> : isFollowed ? <><span className="v2-follow-now"><UserCheck aria-hidden={true} />{isFa ? "\u062F\u0646\u0628\u0627\u0644\u200C\u0634\u062F\u0647" : "Following"}</span><span className="v2-follow-undo" aria-hidden={true}><UserMinus aria-hidden={true} />{undo}</span></> : <><UserPlus aria-hidden={true} />{isFa ? "\u062F\u0646\u0628\u0627\u0644 \u06A9\u0631\u062F\u0646" : "Follow"}</>;
    $[6] = busy;
    $[7] = isFa;
    $[8] = isFollowed;
    $[9] = undo;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== busy || $[12] !== className || $[13] !== isFollowed || $[14] !== t3 || $[15] !== t4 || $[16] !== t5 || $[17] !== t6 || $[18] !== toggle) {
    t7 = <button type="button" className={className} data-followed={t3} aria-pressed={isFollowed} aria-label={t4} aria-busy={t5} disabled={busy} onClick={toggle}>{t6}</button>;
    $[11] = busy;
    $[12] = className;
    $[13] = isFollowed;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = toggle;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  return t7;
}